import type { ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { HomePage } from "@/features/home/HomePage";
import { LoginPage } from "@/features/auth/LoginPage";
import { ForgotPasswordPage } from "@/features/auth/ForgotPasswordPage";
import { ResetPasswordPage } from "@/features/auth/ResetPasswordPage";
import { SignupPage } from "@/features/auth/SignupPage";
import { AccountPage } from "@/features/account/AccountPage";
import { PrivacyPage } from "@/features/legal/PrivacyPage";
import { DpaPage } from "@/features/legal/DpaPage";
import { PricingPage } from "@/features/pricing/PricingPage";
import { DashboardPage } from "@/features/dashboard/DashboardPage";
import { ModulesPage } from "@/features/content/ModulesPage";
import { ModuleEditorPage } from "@/features/content/ModuleEditorPage";
import { SegmentsPage } from "@/features/segments/SegmentsPage";
import { JourneysPage } from "@/features/journeys/JourneysPage";
import { JourneyEditorPage } from "@/features/journeys/JourneyEditorPage";
import { EmployeeProgramPage } from "@/features/program/ProgramPage";
import { TeamReportPage } from "@/features/reports/TeamReportPage";
import { AuditLogPage } from "@/features/reports/AuditLogPage";
import { BrandingPage } from "@/features/branding/BrandingPage";
import { ProtectedRoute } from "@/app/router/ProtectedRoute";

function Managed({ children }: { children: ReactNode }) {
  return <ProtectedRoute minRole="manager">{children}</ProtectedRoute>;
}

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/dpa" element={<DpaPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/app" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/app/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
      <Route path="/app/content" element={<Managed><ModulesPage /></Managed>} />
      <Route path="/app/content/:id" element={<Managed><ModuleEditorPage /></Managed>} />
      <Route path="/app/segments" element={<Managed><SegmentsPage /></Managed>} />
      <Route path="/app/journeys" element={<Managed><JourneysPage /></Managed>} />
      <Route path="/app/journeys/:id" element={<Managed><JourneyEditorPage /></Managed>} />
      <Route path="/app/employees/:id/program" element={<Managed><EmployeeProgramPage /></Managed>} />
      <Route path="/app/reports" element={<Managed><TeamReportPage /></Managed>} />
      <Route path="/app/audit" element={<ProtectedRoute minRole="org_admin"><AuditLogPage /></ProtectedRoute>} />
      <Route path="/app/branding" element={<ProtectedRoute minRole="org_admin"><BrandingPage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
